module.exports = __webpack_public_path__ + "static/prototype-crescent-271f17a6c78b1863e4f382f5c0aca47a.png";